import { Component, Watch, Vue, Emit } from 'vue-property-decorator';
import store from '@/store';
import $ from 'jquery';
// import { fetchLatest } from '@/services/userService';
import SmoothScroll from 'smooth-scroll';
import ButtonLang from '@/components/button/ButtonLang.vue';
@Component({
  components: {
    ButtonLang,
  },
})
export default class DefaultLayout extends Vue {

  get userName(): string {
    return this.$store.getters['auth/name'];
  }
  get userNameEn(): string {
    return this.$store.getters['auth/nameEn'];
  }
  get lang(): string {
    return this.$store.getters['auth/lang'];
  }
  get loaded(): boolean {
    return this.$store.state.loaded;
  }
  get isLogin(): boolean {
    return !!this.$store.getters['auth/token'];
  }
  get isLogedin(): boolean {
    return (this.$store.getters['auth/name']) ? true : false;
  }
  get siteName(): string {
    if (this.lang === 'ja') {
      return process.env.VUE_APP_SITE_NAME;
    } else {
      return process.env.VUE_APP_SITE_NAME_EN;
    }
  }
  get description(): string {
    if (this.lang === 'ja') {
      return process.env.VUE_APP_DISC;
    } else {
      return process.env.VUE_APP_DISC_EN;
    }
  }
  get keywords(): string {
    if (this.lang === 'ja') {
      return process.env.VUE_APP_KEYWORD;
    } else {
      return '';
    }
  }

  @Emit()
  private openModalSearchNavi(): void {
    store.commit('searchmodal/open', 'ModalSearchnavi');
  }

  private mounted() {
    const scroll = new SmoothScroll('a[href^="#"]', {
      ignore: '[href="#"]',
      updateURL: true,
    });
    const route: any = this.$route;
    if (typeof route.hash !== 'undefined' && route.hash === '#search') {
      this.openModalSearchNavi();
    }
  }
}
